module.exports = __webpack_public_path__ + "img/itZert_14001-2015_rgb.eab2a1d.jpg";